import React, { useState, forwardRef } from 'react';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

Transition.displayName = 'Transition';

const FullScreenSettingsDialog = ({ handleDialogClose, title, children }) => {
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
        handleDialogClose();
    };

    return (
        <>
            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                slots={{ transition: Transition }}
            >
                <AppBar sx={{ position: 'sticky' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            {title}
                        </Typography>
                    </Toolbar>
                </AppBar>
                {children}
            </Dialog>
        </>
    );
};

export default FullScreenSettingsDialog;